import(/* webpackMode: "eager" */ "/app/apps/trail-app-router/src/app/global-error.tsx");
